import React from 'react';
import './footerSection.scss';
import {useTranslation} from "react-i18next";

const FooterSection = () => {
	const { t } = useTranslation();

	return (
		<div className="footer">
			<div className="footer__content">
				<div className="footer__content_info">
					<p>{t('footer.interested')}</p>
					<div className="footer__content_info_contacts">
						<span
							onClick={() => window.open('https://wa.me/+4721645447')}
						>
							+47 21 64 54 47
						</span>
						<span
							onClick={() => window.open('https://mail.google.com/mail/?view=cm&fs=1&to=post@kosiband.com')}
						>
							post@kosiband.com
						</span>
					</div>
				</div>
				<div className="footer__content_follow">
					<span>{t('footer.followUs')}:</span>
					<div className="footer__content_follow_icons">
						<button
							onClick={() => window.open('https://www.instagram.com/kosiband')}
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="40"
								height="40"
								viewBox="0 0 40 40"
								fill="none"
							>
								<path
									d="M20 3.61446C25.3012 3.61446 26.0241 3.61446 28.1928 3.61446C30.1205 3.61446 31.0843 4.09639 31.8072 4.33735C32.7711 4.81928 33.494 5.06024 34.2169 5.78313C34.9398 6.50603 35.4217 7.22892 35.6627 8.19277C35.9036 8.91567 36.1446 9.87952 36.3855 11.8072C36.3855 13.9759 36.3855 14.4578 36.3855 20C36.3855 25.5422 36.3855 26.0241 36.3855 28.1928C36.3855 30.1205 35.9036 31.0843 35.6627 31.8072C35.1807 32.7711 34.9398 33.494 34.2169 34.2169C33.494 34.9398 32.7711 35.4217 31.8072 35.6627C31.0843 35.9036 30.1205 36.1446 28.1928 36.3855C26.0241 36.3855 25.5422 36.3855 20 36.3855C14.4578 36.3855 13.9759 36.3855 11.8072 36.3855C9.87952 36.3855 8.91567 35.9036 8.19277 35.6627C7.22892 35.1807 6.50603 34.9398 5.78313 34.2169C5.06024 33.494 4.57831 32.7711 4.33735 31.8072C4.09639 31.0843 3.85542 30.1205 3.61446 28.1928C3.61446 26.0241 3.61446 25.5422 3.61446 20C3.61446 14.4578 3.61446 13.9759 3.61446 11.8072C3.61446 9.87952 4.09639 8.91567 4.33735 8.19277C4.81928 7.22892 5.06024 6.50603 5.78313 5.78313C6.50603 5.06024 7.22892 4.57831 8.19277 4.33735C8.91567 4.09639 9.87952 3.85542 11.8072 3.61446C13.9759 3.61446 14.6988 3.61446 20 3.61446ZM20 0C14.4578 0 13.9759 0 11.8072 0C9.63856 0 8.19277 0.481929 6.98795 0.963857C5.78313 1.44578 4.57832 2.16868 3.3735 3.3735C2.16868 4.57832 1.68675 5.54217 0.963857 6.98795C0.481929 8.19277 0.240964 9.63856 0 11.8072C0 13.9759 0 14.6988 0 20C0 25.5422 0 26.0241 0 28.1928C0 30.3614 0.481929 31.8072 0.963857 33.0121C1.44578 34.2169 2.16868 35.4217 3.3735 36.6265C4.57832 37.8313 5.54217 38.3133 6.98795 39.0362C8.19277 39.5181 9.63856 39.759 11.8072 40C13.9759 40 14.6988 40 20 40C25.3012 40 26.0241 40 28.1928 40C30.3614 40 31.8072 39.5181 33.0121 39.0362C34.2169 38.5542 35.4217 37.8313 36.6265 36.6265C37.8313 35.4217 38.3133 34.4578 39.0362 33.0121C39.5181 31.8072 39.759 30.3614 40 28.1928C40 26.0241 40 25.3012 40 20C40 14.6988 40 13.9759 40 11.8072C40 9.63856 39.5181 8.19277 39.0362 6.98795C38.5542 5.78313 37.8313 4.57832 36.6265 3.3735C35.4217 2.16868 34.4578 1.68675 33.0121 0.963857C31.8072 0.481929 30.3614 0.240964 28.1928 0C26.0241 0 25.5422 0 20 0Z"
									fill="white"
									shapeRendering="geometricPrecision"
									vectorEffect="non-scaling-stroke"
								/>
								<path
									d="M20 9.63856C14.2169 9.63856 9.63856 14.2169 9.63856 20C9.63856 25.7831 14.2169 30.3614 20 30.3614C25.7831 30.3614 30.3614 25.7831 30.3614 20C30.3614 14.2169 25.7831 9.63856 20 9.63856ZM20 26.747C16.3855 26.747 13.253 23.8554 13.253 20C13.253 16.3855 16.1446 13.253 20 13.253C23.6145 13.253 26.747 16.1446 26.747 20C26.747 23.6145 23.6145 26.747 20 26.747Z"
									fill="white"
									shapeRendering="geometricPrecision"
									vectorEffect="non-scaling-stroke"
								/>
								<path
									d="M30.6024 11.8072C31.9332 11.8072 33.0121 10.7284 33.0121 9.39759C33.0121 8.06679 31.9332 6.98795 30.6024 6.98795C29.2716 6.98795 28.1928 8.06679 28.1928 9.39759C28.1928 10.7284 29.2716 11.8072 30.6024 11.8072Z"
									fill="white"
									shapeRendering="geometricPrecision"
									vectorEffect="non-scaling-stroke"
								/>
							</svg>
						</button>
						{/* <button
							onClick={() => window.open('https://www.tiktok.com')}
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="38"
								height="43"
								viewBox="0 0 38 43"
								fill="none"
							>
								<path
									d="M37.9524 10.5072C35.1658 10.5071 32.4934 9.40004 30.523 7.42957C28.5526 5.4591 27.4457 2.78661 27.4457 0H19.939V29.3948C19.9376 30.735 19.5145 32.0407 18.7295 33.1269C17.9446 34.2132 16.8376 35.0248 15.5656 35.4468C14.2936 35.8688 12.9211 35.8798 11.6425 35.4781C10.3639 35.0765 9.24418 34.2826 8.44199 33.209C7.63981 32.1354 7.19586 30.8366 7.17308 29.4966C7.1503 28.1566 7.54983 26.8435 8.31506 25.7432C9.08028 24.643 10.1724 23.8115 11.4366 23.3667C12.7007 22.9218 14.0729 22.8861 15.3585 23.2646V15.9674C12.6263 15.599 9.84681 16.0729 7.39106 17.3258C4.93531 18.5787 2.92023 20.5509 1.61489 22.9792C0.309555 25.4075 -0.223908 28.1762 0.0857384 30.9156C0.395385 33.655 1.5334 36.2348 3.34783 38.3105C5.16225 40.3861 7.56673 41.8588 10.2402 42.5319C12.9136 43.205 15.7288 43.0465 18.3098 42.0776C20.8908 41.1086 23.1147 39.3753 24.6847 37.1091C26.2547 34.8429 27.0959 32.1517 27.0961 29.3948L27.315 14.5367C30.3993 16.8008 34.127 18.0191 37.9532 18.0134L37.9524 10.5072Z"
									fill="white"
									shapeRendering="geometricPrecision"
									vectorEffect="non-scaling-stroke"
								/>
							</svg>
						</button> */}
					</div>
				</div>
				<div className="footer__content_trademark">
					<img
						className={`elasticImage`}
						src={`${process.env.PUBLIC_URL}/assets/images/LogoHameltenproFooter.webp`}
						alt={`Hameltenpro image`}
					/>
					<div className="footer__content_trademark_info">
						<p>Forhandlerportal:</p>
						<div className="footer__content_info_contacts">
							<span
								onClick={() => window.open('https://www.hameltenpro.com')}
							>
								Hameltenpro.com
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default FooterSection;